// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Iq1A","rootMobile":"styles_rootMobile__70jQr"};